export default __webpack_public_path__ + "static/media/img.dea18d76.jpeg";